import styled from 'styled-components';
import media from 'styled-media-query';

export const Button = styled.button`
  font-family: var(--font-menu);
  letter-spacing: 1px;
  border-radius: 5px;
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-3px);
  }
`;
